import React from 'react'

// Helpers
import { formatPercentage } from '../../_helpers'
import ToolTip from '../Tooltip/Tooltip'

export const ProgressBar = (props) => {
  const { bgcolor, details } = props
  const { after_ar_percent, verification_requirement } = details

  // Percents
  const completed = (Number(after_ar_percent) * 100).toFixed(2)
  const requirement = formatPercentage(verification_requirement, 0)

  //Tooltip text
  const filledToolTip = `Client total verifications after invoice schedule will be ${completed}%. Client verification requirement is ${requirement}`
  const notFilledToolTip = `Client verification requirement is ${requirement}. With Invoice Schedule verifications will be at ${completed}%`
  const showRequiredToolTip = verification_requirement > 0 || completed < 100

  // Styles
  const containerStyles = {
    height: 20,
    width: '80%',
    backgroundColor: '#e0e0de',
    borderRadius: 50,
    margin: '0 10%',
    display: 'flex',
  }

  const fillerStyles = {
    height: '100%',
    width: `${completed}%`,
    backgroundColor: bgcolor,
    borderRadius: 'inherit',
    textAlign: 'right',
  }

  const notFilledStyles = {
    height: '100%',
    width: `${100 - completed}%`,
    borderRadius: 'inherit',
  }

  const placeholderStyles = {
    height: '100%',
  }

  const labelStyles = {
    padding: '0 10px',
    color: 'white',
    fontWeight: 'bold',
    zIndex: 2,
  }

  return (
    <div style={containerStyles}>
      <div style={fillerStyles}>
        <ToolTip content={filledToolTip}>
          <div style={labelStyles}>{`${completed}%`}</div>
        </ToolTip>
      </div>

      {showRequiredToolTip && (
        <div style={notFilledStyles}>
          <ToolTip content={notFilledToolTip}>
            <div style={placeholderStyles} />
          </ToolTip>
        </div>
      )}
    </div>
  )
}
